module.exports = BD.Model.extend({
    return: BD.belongsTo('Billy.SalesTaxReturn'),
    entryDate: BD.attr('date'),
    account: BD.belongsTo('Billy.Account'),
    amount: BD.attr('number', { readonly: true }),
    side: BD.attr('side', { readonly: true }),
    isVoided: BD.attr('boolean')
})
